import {nanoid} from 'nanoid'
import qs from 'qs'
import {IframeParent} from '@/enum'

const publicPath = new URL('../../public/env.js', import.meta.url)
const envjs = await import(publicPath.href)

/**
 * 随机字符
 * @returns
 */
export const randomCoding = () => {
  return nanoid()
}

export {default as LogoDom} from './logo'


const {from = ''} = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
})

export const QueryInfo = {
  from
}

/**
 * 是否是管理端
 */
export const IsManagerPro = IframeParent.Admin == from

/**
 * 获取baseUrl
 * @constructor
 */
export const GetBaseUrl = () => {
  // const BASE_DEV_URL = "http://localhost:8208/"
  const BASE_DEV_URL = "https://tmc-server.z3a105.com/"
  const BASE_PROD_URL = "https://ebridge-travel.hosecloud.com/"
  let _url = location.href
  if (_url.indexOf('ebridge-travel-web') > -1) {
    return BASE_PROD_URL
  }
  return envjs.LOCAL_BASE_URL
}
